import React, { useState } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonGroup, Button } from '@mui/material';

import Icon from '@mdi/react';
import {
    mdiDelete, mdiFilePdfBox, mdiMicrosoftExcel,
    mdiEmailArrowRight, mdiCloseOctagon
} from '@mdi/js';
import { reportDetailViewSelector, setReportDetailView } from '../../features/datacenter/reportSlice';
import { deleteReport, getExcel, getPdf, } from '../../features/datacenter/datacenterApi';

import GetPdfForm from '../common/GetPdfForm';


const ReportDetailHeader = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const dispatch = useDispatch();
    const reportID = reportData.reportID;
    const reportDetailView = useSelector(reportDetailViewSelector);


    const deleteTrackCallback = () => {
        if (reportDetailView === reportID) {
            dispatch(setReportDetailView(null));
        }
        dispatch(deleteReport(reportID));
    }

    const [getPdfFormOpen, setgetPdfFormOpen] = useState(false);
    const handleGetPdfFormClose = () => {
        setgetPdfFormOpen(false);
    }

    const removeTrackDetailViewCallback = () => {
        dispatch(setReportDetailView(null));
    }

    return (
        <Paper style={{ ...dimentions.reportDetailViewTop }}>
            <div style={{ margin: '5px', marginRight: '5px' }}>
                <Grid container spacing={1} justifyContent="space-between">
                    <Grid item sm={12}>
                        <div style={{ marginLeft: '5px' }}>
                            <Typography variant="h6" color="textPrimary">
                                <b>{reportData.reportName} Report</b>
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                {reportData.assetName}
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item sm={12}>


                        <ButtonGroup variant="text">
                            <Button
                                size="small"
                                startIcon={
                                    <Icon
                                        path={mdiMicrosoftExcel}
                                        title="Download Excel"
                                        size={0.8}
                                        color="Green"
                                    />
                                }
                                onClick={() => dispatch(getExcel(reportID))}
                            >Excel </Button>
                            <Button
                                size="small"
                                startIcon={
                                    <Icon
                                        path={mdiFilePdfBox}
                                        title="Download PDF"
                                        size={0.8}
                                        color="Crimson"
                                    />
                                }
                                onClick={() => dispatch(getPdf(reportID))}
                            >PDF </Button>
                            <Button
                                size="small"
                                startIcon={
                                    <Icon
                                        path={mdiEmailArrowRight}
                                        title="Email PDF"
                                        size={0.8}
                                        color="Teal"
                                    />
                                }
                                onClick={() => setgetPdfFormOpen(true)}
                            >Send Mail </Button>
                            {/*<Button
                                size="small"
                                disabled
                                startIcon={
                                    <Icon
                                        path={mdiShareVariant}
                                        title="Share Track"
                                        size={0.8}
                                        color="DodgerBlue"
                                    />
                                }
                                onClick={() => { }}
                            >Share </Button>
                            <Button
                                size="small"
                                disabled
                                startIcon={
                                    <Icon
                                        path={mdiContentSave}
                                        title="Save This Track"
                                        size={0.8}
                                        color="DarkMagenta"
                                    />
                                }
                                onClick={() => { }}
                            >Save for Later </Button>*/}
                            <Button
                                size="small"
                                startIcon={
                                    <Icon
                                        path={mdiDelete}
                                        title="Delete Track"
                                        size={0.8}
                                        color="Red"
                                    />
                                }
                                onClick={deleteTrackCallback}
                            >Delete </Button>
                            <Button
                                onClick={removeTrackDetailViewCallback}
                                startIcon={<Icon
                                    path={mdiCloseOctagon}
                                    title="Hide Track Player"
                                    size={0.8}
                                    color="Crimson"
                                />}
                            >
                                Close
                            </Button>
                        </ButtonGroup>

                    </Grid>
                </Grid>
                <GetPdfForm
                    getPdfFormOpen={getPdfFormOpen}
                    handleGetPdfFormClose={handleGetPdfFormClose}
                    reportIDs={[reportID]}
                />
            </div>
        </Paper>
    );
}

export default ReportDetailHeader;
